module.exports = __webpack_public_path__ + "img/sombra-carpa.fabc3ba4.png";